import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'
import React from 'react'

export const AppMotorConsent: React.FC = () => {

    const data = [
        {
            'type': 1,
            'content': 'Consent for Disclosure',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'I/We hereby consent and authorize SHENMA Credit Sdn Bhd to collect, process, give, produce, divulge, reveal, publish or otherwise disclose, or make a record of my/our personal and financial particulars as well as particulars of the my/our account with the SHENMA Credit Sdn Bhd and the particulars of the Goods, to any company related to the SHENMA Credit Sdn Bhd within the meaning of the Companies Act 2016, or to any credit reporting agency or any credit bureau or agency approved by the Association of Finance Companies of Malaysia, Association of Banks in Malaysia, Association of Credit Companies Malaysia, Association of Hire Purchase Companies Malaysia or the Central Credit Bureau of Bank Negara Malaysia or any other authority or body (governmental or otherwise) as the SHENMA Credit Sdn Bhd may be required to under any applicable law, regulations, directives or guidelines (whether having the force of law or otherwise), as well as to any party whom in SHENMA Credit Sdn Bhd sole judgment considers is making enquiries with a bona fide view to entering into a prospective transaction with me/us, to any party pursuant to any arrangement, composition, restructuring or any proposed arrangement, composition, restructuring with me/us as well as to any collection agency or any other person appointed by the SHENMA Credit Sdn Bhd to assist the SHENMA Credit Sdn Bhd in collecting or recovering any sums due under this Agreement or repossessing, recovering or disposing of Goods.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Consent for Marketing',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '1. I/We consent and authorize SHENMA Credit Sdn Bhd to collect, process and disclose any of my/our information that I/we have provided for the purposes of cross selling, marketing. promotions (including administering offers and competitions) of products and services and conducting surveys (to improve the quality of products/services) to SHENMA Credit\'s related group of companies, strategic partners, service providers and its agent, servant and/or such persons or any third business partners or strategic alliances whether existing or in the future as parties as SHENMA Credit Sdn Bhd deemed necessary or expedient.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '2. I/We hereby confirm that no further permission or consent from me/us is/are necessary or required in relation thereto and this shall constitute the consent required under the Personal Data Protection Act 2010 and any other contractual consent for such disclosure of information.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '3. I/We hereby agree to receive promotional SMS materials, mailers, e-mails and telemarketing calls from SHENMA Credit Sdn Bhd and other companies within the SHENMA Group.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '4. In the event that I/we do not wish to receive such marketing calls or promotional material, I/We may opt out by visiting SHENMA Credit Sdn Bhd or write to the Customer Care at wecare@shenmacredit.com.my.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Consent for Declaration of Data Privacy',
            'paddingLeft': '0px',
            'underline': false
        },
        
        {
            'type': 2,
            'content': '1. l/We hereby consent and authorize SHENMA Credit Sdn Bhd to collect, process, give, produce, divulge, reveal, publish or otherwise disclose, or make a record of my/our personal and financial particulars as well as particulars of my/our account with SHENMA Credit Sdn Bhd and the particulars of the Goods, to any company related to SHENMA Credit Sdn Bhd within the meaning of the Company Act 2016 or to any credit reporting agency or any credit bureau or agency approved by the Association of Finance Companies of Malaysia, Association of Banks in Malaysia, Association of Credit Companies Malaysia, Association of Hire Purchase Companies Malaysia or the Central Credit Bureau of Bank negara Malaysia or any other authority or body (governmental or otherwise) as SHENMA Credit Sdn Bhd may be required to under any applicable law, regulations, directives or guidelines (whether having the force of law or otherwise), as well as to any party whom in SHENMA Credit Sdn Bhd’s sole judgement considers is making enquiries with a bona fide view to entering into a prospective transaction with me/us, to any party pursuant to any arrangement, composition, restructuring or any proposed arrangement, composition, restructuring with me/us as well as to any collection agency or any other person appointed by SHENMA Credit Sdn Bhd to assist SHENMA Credit Sdn Bhd in collecting or recovering any sum due under this Agreement or repossessing, recovering or disposing of Goods.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '2. I/We also hereby consent and authorize the Dealer to act on my/our behalf to instruct, receive, peruse, liaise and submit all of my/our documentation/instruction to SHENMA Credit Sdn Bhd, which concerned but not limited to this Islamic Hire-Purchase Application. I/We hereby consent and authorize SHENMA Credit Sdn Bhd to provide, release, produce, divulge, reveal or otherwise disclose an information/status/document pertaining to my/our Islamic Hire-Purchase Application/Account to the Dealer. I/We also consent and authorize SHENMA Credit Sdn Bhd to obtain, receive, verify, release and liaise directly with the Dealer on matters relating to my/our Islamic Hire-Purchase Application/Account.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '3. Besides that, the I/We also expressly consent, permit and authorize SHENMA Credit Sdn Bhd to disclose to any relevant authority, including but not limited to, the Central Bank of Malaysia and the officer or Controller or Assistant Controller appointed by the Ministry of Domestic Trade and Consumer Affairs or relevant authorities all of my/our information, documents, data, accounts, financial information whatsoever as may be requested by the relevant authority in accordance to Law of Malaysia.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '4. I/We hereby confirm that no further permission or consent from me/us is necessary or required in relation thereto and this shall constitute the consent required under the Personal Data Protection Act 2010 and any other contractual consent for such disclosures of information.',
            'paddingLeft': '12px',
            'underline': false
        },
        {
            'type': 2,
            'content': '5. Please take note that the consequence in not giving your concern here would result in SHENMA Credit Sdn Bhd unable to grant the facility to you.',
            'paddingLeft': '12px',
            'underline': false
        },
    
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }

    return (
        <Box sx={{
            width: '100%',
            paddingTop: isDesktop ? '60px' : '30px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '100px' : '20px',
            paddingRight: isDesktop ? '100px' : '20px',
        }}>
            <Grid container rowSpacing={2}>
                {data.map((item, index) => (
                    data[index]['type'] === 1 ? titleItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline']) : contentItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline'])
                ))}
            </Grid>
        </Box>
    )
}
